import * as React from 'react'
import dynamic from 'next/dynamic'

import { styled, spacing, css } from '@thg-commerce/enterprise-theme'
import { Button } from '@thg-commerce/gravity-elements'

const SvgAddToWishlist = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/FavouritesOutline'),
  { loading: () => <div style={{ width: 24, height: 24 }} /> },
)

const HeartIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/WishlistSelected'),
  { loading: () => <div style={{ width: 24, height: 24 }} /> },
)

const smallWishlistProperties = css`
  height: 48px;
  width: 48px;
  min-width: 48px;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.palette.brand.base};
  margin: 0 0 0 ${spacing(1)};

  svg {
    margin: ${spacing(0.75)};
  }
`
const buttonProperties = css<{
  selected?: boolean
  smallButton?: boolean
}>`
  ${(props) =>
    !props.smallButton
      ? css`
          border-radius: 50%;
          padding: calc(${spacing(1)} - 2px);
          border-width: 2px;
        `
      : css`
          border-radius: 0;
        `}

  svg {
    fill: ${(props) =>
      props.selected ? 'currentColor' : props.theme.colors.palette.greys.white};
  }
`

export const StyledButton = styled(Button)<{
  heartButton?: boolean
  smallButton?: boolean
}>`
  text-decoration: none;

  ${(props) =>
    props.smallButton &&
    css`
      ${smallWishlistProperties}

      &:hover,
      &:focus,
      &:active {
        ${smallWishlistProperties}
      }
    `}

  ${(props) =>
    props.heartButton &&
    css`
      ${buttonProperties}

      &:hover {
        background-color: ${props.theme.colors.palette.brand.lightest};
        ${buttonProperties}
      }

      &:focus,
      &:active {
        background-color: ${props.theme.colors.palette.brand.lighter};
        ${buttonProperties}
      }
    `}
`

const svgWishlistProperties = css`
  width: 20px;
  height: 20px;
  margin: 0 ${spacing(1)} 0 ${spacing(-0.5)};
`

export const StyledSvgAddToWishlist = styled(SvgAddToWishlist)`
  ${svgWishlistProperties}
`

export const StyledHeartIcon = styled(HeartIcon)<{
  heartButton?: boolean
}>`
  display: block;
  stroke: currentColor;
  stroke-width: 2px;

  ${(props) =>
    props.heartButton
      ? `
      width: 24px;
      height: 24px;
      `
      : svgWishlistProperties}
`

export const WishlistContentContainer = styled.div`
  display: flex;
  align-items: center;
`
